import http from "../helpers/http";

export const getSubscriptions = async (params = {}) => {
    const response = await http().get("/merchants/subscriptions", { params });
    return response.data;
};

export const getSubscriptionsSandbox = async (params = {}) => {
    const response = await http().get("/sandbox/subscriptions", { params });
    return response.data;
};

export const getPlans = async () => {
    const response = await http().get("/merchants/subscriptions/Get-my-plans");
    return response.data;
};

export const getPlansSandbox = async () => {
    const response = await http().get("/sandbox/plans");
    return response.data;
};

export const createPlan = async (payload) => {
    const response = await http().post("/merchants/subscriptions", payload);
    return response.data;
};

export const createPlanSandBox = async (payload) => {
    const response = await http().post("/sandbox/plans", payload);
    return response.data;
};

export const updatePlan = async (planId, payload) => {
    const response = await http().put(`/merchants/subscriptions/${planId}`, payload);
    return response.data;
};

export const updatePlanSandbox = async (planId, payload) => {
    const response = await http().put(`/sandbox/plans//${planId}`, payload);
    return response.data;
};

export const deletePlan = async (planId) => {
    const response = await http().delete(`/merchants/subscriptions/${planId}`);
    return response.data;
};
export const deletePlanSandbox = async (planId) => {
    const response = await http().delete(`/sandbox/plans${planId}`);
    return response.data;
};

export const getSubscriptionReport = async (params = {}) => {
    const response = await http().get("/merchants/subscriptions/report", {
        params,
        responseType: 'blob'
    });
    return response.data;
};